// @ts-check
import { Box, Button, StarIcon } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../../pages/imports/_config';
import Layout from '../Layout/Layout';
import PageSubtitle from '../Layout/PageSubtitle';
import PageTitle from '../Layout/PageTitle';

/**
 * Renders the import in progress page
 * @param {Object} props
 * @param {Object} [props.importData] - the import data
 */
export default function DefaultImportInProgressPage({ importData }) {
  const link = useCommonLinks();
  return (
    <Layout>
      <Box sx={{ textAlign: 'center' }}>
        <StarIcon sx={{ height: 120, width: '120px' }} />
        <PageTitle>
          <Trans>Processing Import</Trans>
        </PageTitle>
        {importData.state.progress >= 0 && (
          <PageTitle sx={{ marginLeft: 1 }}>
            {importData.state.progress}%
          </PageTitle>
        )}
        <PageSubtitle>
          <Trans>Your data is being imported.</Trans>
        </PageSubtitle>
        <Box sx={{ marginTop: 5 }}>
          <Button variant="primary" to={link.root()}>
            <Trans>View imports</Trans>
          </Button>
        </Box>
      </Box>
    </Layout>
  );
}
